import { useQuery } from "@tanstack/react-query";
import { api, ForbiddenError, UnauthorizedError } from "@/api/client";

export function useAuth() {
  const q = useQuery({
    queryKey: ["me"],
    queryFn: api.me,
    retry: (count, err) =>
      !(err instanceof UnauthorizedError) && !(err instanceof ForbiddenError) && count < 1,
  });
  return {
    user: q.data ?? null,
    loading: q.isLoading,
    authenticated: !!q.data,
    unauthorized: q.error instanceof UnauthorizedError,
    // 403 — pilgrims 인증은 됐으나 웹채팅 사용자 미등록/사용 해제(관리자 등록 필요)
    denied: q.error instanceof ForbiddenError ? q.error : null,
    error:
      q.error && !(q.error instanceof UnauthorizedError) && !(q.error instanceof ForbiddenError)
        ? q.error
        : null,
  };
}
